import Icon from 'components/shared/icon';
import { useEffect, useRef, useState } from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';
import { DebounceInput } from 'react-debounce-input';
import { useRouter } from 'next/router';
import styles from './searchBox.module.scss';

const SearchBox = ({ refine, currentRefinement, globals }) => {
  const [searchQuery, setSearchQuery] = useState(undefined);

  const inputEl = useRef();
  const router = useRouter();
  const { searchSuggestions, trending, search } = globals[0];

  // Refine search if the url contains search query (saved Query URL functionality)
  useEffect(() => {
    if (router.query?.query?.length && searchQuery === undefined) {
      refine(router.query?.query);
      setSearchQuery(router.query?.query);
    }

    // leaving search page or removing all text from search input
    if (!router.query?.query?.length) {
      setSearchQuery(undefined);
    }
  }, [router.query?.query, searchQuery, setSearchQuery, refine]);

  const goToResultsAndRefine = newQuery => {
    if (currentRefinement?.length || router.query?.query?.length) {
      router.push({
        pathname: '/search',
        query: { query: newQuery },
      });
    } else {
      router.replace({
        pathname: '/search',
        query: newQuery && { query: newQuery },
      });
    }
    refine(newQuery);
    setSearchQuery(newQuery);
  };

  return (
    <>
      <div className={styles.searchBoxWrapper}>
        <DebounceInput
          minLength={1}
          inputRef={inputEl}
          value={searchQuery}
          debounceTimeout={300}
          placeholder={search?.text}
          autoFocus
          type="search"
          className={styles.searchBox}
          onChange={e => {
            goToResultsAndRefine(e.target.value);
          }}
        />
        <Icon type="search" className={styles.searchIcon} />
      </div>
      {!currentRefinement && (
        <div className={styles.emptySearchWrapper}>
          <h3 className={styles.resultsText}>{trending?.text}</h3>
          <div className={styles.searchSuggestionWrapper}>
            {searchSuggestions?.texts?.map(suggestion => (
              <button
                type="button"
                className={styles.searchSuggestion}
                key={suggestion}
                onClick={() => goToResultsAndRefine(suggestion)}
              >
                {suggestion}
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

const CustomSearchBox = connectSearchBox(SearchBox);

export default CustomSearchBox;
